// @flow
import * as React from 'react'
import KeyboardSelectable from 'mz-ui-kit/core/KeyboardSelectable'
import { TabContainer, TabIcon } from './elements'

// Types
import type { Value } from './Tabs'

export type CommonTabProps = {
  appearance?: 'material' | 'rect',
  indicatorColor?: string,
  tabColor?: string,
  activeTabColor?: string,
}
export type Props = CommonTabProps & {
  children: ?React.Node,
  renderIcon?: () => React.Node,
  key?: number,
  value?: Value,
  isActive?: Boolean,
  onSelect?: Function,
  mobile?: Boolean,
}

class Tab extends React.Component<Props> {
  handleClick = (event: Object) => {
    const { value, onSelect } = this.props
    event.preventDefault()
    onSelect && onSelect(value)
  }

  render() {
    const {
      appearance,
      isActive,
      indicatorColor,
      tabColor,
      activeTabColor,
      children,
      renderIcon,
      key,
      mobile,
      ...others
    } = this.props

    return (
      <KeyboardSelectable
        render={({ keyDownHandler }) => (
          <TabContainer
            $appearance={appearance}
            key={key}
            tabIndex="0"
            onClick={this.handleClick}
            onKeyDown={keyDownHandler(this.handleClick)}
            $active={isActive}
            $indicatorColor={indicatorColor}
            $tabColor={tabColor}
            $activeTabColor={activeTabColor}
            $mobile={mobile}
            role="tab"
            aria-selected={isActive}
            {...others}
          >
            {renderIcon && <TabIcon>{renderIcon()}</TabIcon>}
            {children}
          </TabContainer>
        )}
      />
    )
  }
}

export default Tab
